import Http from '@/services/http';
import {
  OscillographyAnalysisDiagnosticLimitParameters,
} from 'sigma-mappings';

const urls = {
  diagnosticLimits: assetModuleId => `/engenharia/analise-oscilografia/${assetModuleId}/parametros/limites-diagnostico`,
  defaultDiagnosticLimits: assetModuleId => `/engenharia/analise-oscilografia/${assetModuleId}/parametros/limites-diagnostico/padrao`,
};

const mapDiagnosticLimits = data => data
  .map(item => new OscillographyAnalysisDiagnosticLimitParameters(item))
  .filter(item => item.variable && item.maneuverType);

export default {
  getDiagnosticLimits(assetModuleId) {
    const http = new Http();
    return http.get(urls.diagnosticLimits(assetModuleId)).then(
      ({ data }) => mapDiagnosticLimits(data),
    );
  },
  getDefaultDiagnosticLimits(assetModuleId) {
    const http = new Http();
    return http.get(urls.defaultDiagnosticLimits(assetModuleId)).then(
      ({ data }) => mapDiagnosticLimits(data),
    );
  },
  putDiagnosticLimits(assetModuleId, payload = []) {
    const http = new Http();
    const mappedPayload = payload.map(
      item => new OscillographyAnalysisDiagnosticLimitParameters.MapBack(item),
    );
    return http.put(urls.diagnosticLimits(assetModuleId), mappedPayload);
  },
};
